export default __webpack_public_path__ + "static/media/3A.8d90410f.jpg";